import React from "react";
import Icon from "../../../components/AppIcon";

const FormSelect = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  options = [],
  placeholder = "Select an option",
  required = false,
  className = "",
  ...props
}) => {
  const id = `form-select-${name}`;
  const hasError = Boolean(error);
  
  return (
    <div className={className}>
      <div className="flex justify-between">
        <label 
          htmlFor={id} 
          className="block text-sm font-medium text-gray-700"
        >
          {label} {required && <span className="text-error">*</span>}
        </label>
        
        {hasError && (
          <span className="text-sm text-error flex items-center">
            <Icon name="AlertCircle" size={14} className="mr-1" />
            {error}
          </span>
        )}
      </div>
      
      <div className="mt-1 relative">
        <select
          id={id}
          name={name}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          className={`
            block w-full rounded-md shadow-sm 
            focus:ring-primary focus:ring-2 focus:outline-none
            ${hasError 
              ? 'border-error focus:border-error' :'border-gray-300 focus:border-primary-500'
            }
          `}
          aria-invalid={hasError}
          aria-describedby={hasError ? `${id}-error` : undefined}
          {...props}
        >
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <Icon name="ChevronDown" size={16} className="text-gray-400" />
        </div>
      </div>
      
      {hasError && (
        <p className="mt-2 text-sm text-error" id={`${id}-error`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default FormSelect;